export const config = {
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  SCOPES: [process.env.REACT_APP_SCOPES],
  AUTHORITY: process.env.REACT_APP_AUTHORITY,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
};
